export type ConvertPropsToStyled<T extends { [k: string]: any }> = {
  [key in keyof T as `$${string & key}`]: T[key];
};

export const convertPropsToStyled = <T extends { [k: string]: any }>(p: T) =>
  Object.fromEntries(Object.keys(p).map(key => [`$${key}`, p[key]]));
